import { Box } from 'ink';
import React, { useMemo, useContext } from 'react';
import type { ReactNode } from 'react';
import type { BoxProps } from 'ink';
import { UnorderedListItem } from './UnorderedListItem.js';
import { UnorderedListContext } from './UnorderedListContext.js';
import { UnorderedListItemContext } from './UnorderedListItemContext.js';
import { defaultMarker } from './DefaultMarker.js';

export type UnorderedListProps = {
  children: ReactNode;
  marker?: string;
} & Omit<BoxProps, 'marginLeft' | 'flexDirection'>;

export function UnorderedList({
  children,
  marker: markerOverride,
  ...style
}: UnorderedListProps) {
  const { depth } = useContext(UnorderedListContext);
  const { marker } = useContext(UnorderedListItemContext);

  const listContext = useMemo(
    () => ({
      depth: depth + 1,
    }),
    [depth]
  );

  const listItemContext = useMemo(() => {
    if (typeof markerOverride === 'string') {
      return { marker: markerOverride };
    }

    if (typeof marker === 'string') {
      return { marker };
    }

    return { marker: defaultMarker };
  }, [marker, markerOverride]);

  return (
    <UnorderedListContext.Provider value={listContext}>
      <UnorderedListItemContext.Provider value={listItemContext}>
        <Box {...style} flexDirection="column" marginLeft={depth * 2}>
          {children}
        </Box>
      </UnorderedListItemContext.Provider>
    </UnorderedListContext.Provider>
  );
}

UnorderedList.Item = UnorderedListItem;
